import { getLogger } from '../logging/functions';
export default getLogger('features/base/i18n');
